import { MAX_BILDER } from '../../../utils/clipboardImages';
import { API_URL } from '../../../utils/api';

/**
 * Ladda upp skärmbilder till en granskningskommentar och få tillbaka S3-URL:er.
 *
 * Tillståndslös med avsikt. useGranskningsbilder bygger på den för de fält som
 * har EN kommentarsruta, men markeringarna i PDF:en har en ruta per markering —
 * där är highlight-listan redan tillståndet, och en hook per ruta hade bara
 * riskerat att blanda ihop bilder mellan markeringar.
 *
 * Kastar vid fel, med serverns meddelande när det finns (för stor fil, fel
 * filtyp, för många anrop). Anroparen ska visa det — en avvisad uppladdning ser
 * annars ut som att inklistringen inte fungerade.
 *
 * @param {string} projectId
 * @param {File[]} filer
 * @returns {Promise<string[]>} S3-URL:er
 */
export const laddaUppGranskningsbilder = async (projectId, filer) => {
  if (!projectId || !filer || filer.length === 0) return [];

  const formData = new FormData();
  // Kapas här också: servern tar max 5 per anrop (multer .array('images', 5)).
  filer.slice(0, MAX_BILDER).forEach(fil => formData.append('images', fil));

  const token = localStorage.getItem('token');
  // Ingen Content-Type — webbläsaren måste sätta den själv för att
  // multipart-boundary ska komma med.
  const res = await fetch(`${API_URL}/api/ritningar/project/${projectId}/review-images`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || 'Kunde inte ladda upp bilden');
  }

  return data.images || [];
};
